import { useState } from 'react';
import { Col, Form as FormB, FormCheck, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { postActaGenerica } from '../../../../appStore/actas';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import { Accordion } from '../../../Accordion/Accordion';
import { AccordionItem } from '../../../Accordion/AccordionItem';
import Form from '../../../CompUtils/Form';

const CenterDiv = styled.div`
  margin: 0 auto;
  width: 600px;
`;

export interface NuevaActaForm {
  titulo: string;
  descripcion: string;
  vistaPublica: boolean;
  firmaCerrada: boolean;
  adjuntoCerrado: boolean;
  archivoActa: File;
}

export const AdjuntarNuevaActa = () => {
  const [values, setValues] = useState({
    titulo: '',
    descripcion: '',
    vistaPublica: false,
    firmaCerrada: false,
    adjuntoCerrado: false,
  });
  const [documento, setDocumento] = useState<any>();
  const { idLlamadoConcurso } = useConcurso();
  const dispatch = useDispatch();
  const handleActa = () => {
    dispatch(postActaGenerica({ idLlamadoConcurso, ...values, archivoActa: documento }));
  };

  return (
    <Accordion>
      <AccordionItem title="Adjuntar nueva acta">
        <CenterDiv>
          <Form onSubmit={handleActa} submitText="Enviar Acta" btns={['submit']}>
            <Row>
              <Col xs={12}>
                <FormB.Group>
                  <FormB.Label>Título</FormB.Label>
                  <FormB.Control
                    id="titulo"
                    value={values.titulo}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        titulo: e.target.value,
                      });
                    }}
                  />
                </FormB.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormB.Group>
                  <FormB.Label>Descripción</FormB.Label>
                  <FormB.Control
                    as="textarea"
                    id="descripcion"
                    value={values.descripcion}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        descripcion: e.target.value,
                      });
                    }}
                  />
                </FormB.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <FormCheck
                  type="checkbox"
                  checked={values.vistaPublica}
                  id="vistaPublica"
                  label="Vista Pública"
                  onChange={() => {
                    setValues({
                      ...values,
                      vistaPublica: !values.vistaPublica,
                    });
                  }}
                />
              </Col>
              <Col xs={4}>
                <FormCheck
                  type="checkbox"
                  checked={values.firmaCerrada}
                  id="firmaCerrada"
                  label="Firma Cerrada"
                  onChange={() => {
                    setValues({
                      ...values,
                      firmaCerrada: !values.firmaCerrada,
                    });
                  }}
                />
              </Col>
              <Col xs={4}>
                <FormCheck
                  type="checkbox"
                  checked={values.adjuntoCerrado}
                  id="adjuntoCerrado"
                  label="Adjunto Cerrado"
                  onChange={() => {
                    setValues({
                      ...values,
                      adjuntoCerrado: !values.adjuntoCerrado,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormB.Group as={Col}>
                  <FormB.Label>Subir ACTA</FormB.Label>
                  <FormB.File id="acta" custom>
                    <FormB.File.Input
                      name="acta"
                      accept=".pdf"
                      type="file"
                      onChange={(ev: any) => {
                        setDocumento(ev.currentTarget.files[0]);
                      }}
                    />
                    <FormB.File.Label data-browse="Cargar archivo">
                      {documento?.name}
                    </FormB.File.Label>
                  </FormB.File>
                </FormB.Group>
                {/*                 <FileInput
                  id="archivoActa"
                  title="Subir ACTA"
                  accept="application/pdf"
                  validate={Yup.string().nullable().required()}
                /> */}
              </Col>
            </Row>
          </Form>
        </CenterDiv>
      </AccordionItem>
    </Accordion>
  );
};
